import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { CdkStep } from '@angular/cdk/stepper';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { map, startWith, Subject, switchMap, takeUntil } from 'rxjs';
import { ExpansionPanelComponent } from '../expansion-panel.component';

@Component({
    selector: 'lui-expansion-step',
    template: '<ng-template><ng-content></ng-content></ng-template>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ExpansionStepComponent
  extends CdkStep
  implements AfterContentInit, OnDestroy
{
  @HostBinding('class.active') get ActiveClass() {
    return true;
  }

  @ContentChild(ExpansionPanelComponent) expansion!: ExpansionPanelComponent;

  @Input()
  override get completed(): boolean {
    return this._completedOverride == null
      ? this._getDefaultCompletedOverride()
      : this._completedOverride;
  }
  override set completed(value: BooleanInput) {
    const completed = coerceBooleanProperty(value);
    this._completedOverride = completed;
    if (completed) {
      this.stepCompleted.emit(coerceBooleanProperty(value));
    }
  }

  isSelectedStream$ = this._stepper.steps.changes.pipe(
    switchMap(() => {
      return this._stepper.selectionChange.pipe(
        map((event) => event.selectedStep === this),
        startWith(this._stepper.selected === this)
      );
    })
  );

  destroyed = new Subject<void>();

  @Output() stepCompleted = new EventEmitter<boolean>();

  ngAfterContentInit() {
    this.isSelectedStream$
      .pipe(takeUntil(this.destroyed))
      .subscribe((isSelected) => {
        if (isSelected && this.expansion) {
          if (!this.expansion.expanded) {
            this.expansion.open();
          }
        }
        if (!isSelected && this.expansion) {
          if (this.expansion.expanded) {
            this.expansion.close();
          }
        }
      });

    this.expansion.headerClicked.subscribe(() => {
      this.select();
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  toggleDisabled(v: boolean) {
    this.expansion.toggleStepperDisabled(v);
  }

  private _getDefaultCompletedOverride() {
    return this.stepControl
      ? this.stepControl.valid && this.interacted
      : this.interacted;
  }
}
